import ReactBoot from "../../../utils/ReactBoot";

import TrafficWebcamComponent from "./TrafficWebcamComponent";
import TrafficRoadmapComponent from "./TrafficRoadmapComponent";
import TrafficParkingComponent from "./TrafficParkingComponent";


ReactBoot.tryBoot(TrafficWebcamComponent, "traffic-cameras");
ReactBoot.tryBoot(TrafficRoadmapComponent, "google-map");
ReactBoot.tryBoot(TrafficParkingComponent, "parking");



// WEBPACK FOOTER //
// ./js/services/traffic/Traffic.js